export function createStyleNode(id?: string) {
  if (id) {
    const oldNode = document.getElementById(id);
    if (oldNode) {
      oldNode.parentNode!.removeChild(oldNode);
    }
  }
  const styleNode = document.createElement("style");
  styleNode.setAttribute("type", "text/css");
  if (id) {
    styleNode.id = id;
  }
  document.head.appendChild(styleNode);
  return styleNode;
}
